/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerFindOneQueryResponse, FilesControllerFindOnePathParams, FilesControllerFindOneQueryParams, FilesControllerFindOne400, FilesControllerFindOne401, FilesControllerFindOne403, FilesControllerFindOne404 } from "../../models/filesController/FilesControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { filesControllerFindOne } from "../../clients/filesService/filesControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const filesControllerFindOneQueryKey = (id: FilesControllerFindOnePathParams["id"], params: FilesControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/files/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type FilesControllerFindOneQueryKey = ReturnType<typeof filesControllerFindOneQueryKey>;
export function filesControllerFindOneQueryOptions(id: FilesControllerFindOnePathParams["id"], params?: FilesControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = filesControllerFindOneQueryKey(id, params);
  return queryOptions<FilesControllerFindOneQueryResponse, ResponseErrorConfig<FilesControllerFindOne400 | FilesControllerFindOne401 | FilesControllerFindOne403 | FilesControllerFindOne404>, FilesControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return filesControllerFindOne(id, params, config);
    }
  });
}

/**
 * @description Returns File object from the database.
 * @summary Get file by ID
 * {@link /api/v1/files/:id}
 */
export function useFilesControllerFindOne<TData = FilesControllerFindOneQueryResponse, TQueryData = FilesControllerFindOneQueryResponse, TQueryKey extends QueryKey = FilesControllerFindOneQueryKey>(id: FilesControllerFindOnePathParams["id"], params?: FilesControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<FilesControllerFindOneQueryResponse, ResponseErrorConfig<FilesControllerFindOne400 | FilesControllerFindOne401 | FilesControllerFindOne403 | FilesControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? filesControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...filesControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FilesControllerFindOne400 | FilesControllerFindOne401 | FilesControllerFindOne403 | FilesControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}